// extracted by mini-css-extract-plugin
export var actionButton = "_7s-1";
export var actionButtons = "_7s-2";
export var actions = "_7s-0";
export var aiUnread = "_7s-10";
export var alignCenter = "_7s-h";
export var backWrapper = "_7s-3";
export var cellContainer = "_7s-4";
export var checkboxContainer = "_7s-5";
export var contentContainer = "_7s-6";
export var contentHeader = "_7s-8";
export var conversationsTableWrapper = "_7s-s";
export var draftReplyBadgeContainer = "_7s-m";
export var dropdownItem = "_7s-b";
export var dropdownItemsContainer = "_7s-a";
export var dropdownTitle = "_7s-c";
export var errorIcon = "_7s-7";
export var filter = "_7s-d";
export var gray = "_7s-i";
export var headerActionButtons = "_7s-e";
export var headerCheckboxContainer = "_7s-f";
export var icon = "_7s-j";
export var menuContainer = "_7s-k";
export var noMoreTicketsIcon = "_7s-12";
export var noMoreTicketsSubText = "_7s-13";
export var oneLine = "_7s-l";
export var optionsButton = "_7s-n";
export var plus = "_7s-o";
export var portalButtonsWrapper = "_7s-g";
export var red = "_7s-p";
export var scrolledTop = "_7s-9";
export var search = "_7s-q";
export var selectedConversationsCount = "_7s-r";
export var spinner = "_7s-t";
export var strong = "_7s-u";
export var summaryCell = "_7s-v";
export var tableContainer = "_7s-11";
export var tagContainer = "_7s-w";
export var threeDots = "_7s-x";
export var twoLines = "_7s-y";
export var unread = "_7s-z";